
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {ApiConstant} from '../api.constant';
import {HttpManagerService}  from '../../api/httpmanager.service';

@Injectable()
export class HiringRequestService {
    private mainurl : String;
    constructor(private apiservice: ApiConstant,
                private httpmanagerService: HttpManagerService) {
        this.mainurl = apiservice.ServerUrl;

    }
    allHiring(): Promise<any> {
        return this.httpmanagerService.HttpGet('hiringrequest', "").then(function (data) {

            return data.data;
        });
    }

    downloadFile(name)
    {
        // window.location.href=this.mainurl+'butbxbbcsb/uploads/cover_letter/'+name;
        window.open(this.mainurl+'uploads/cover_letter/'+name, "_blank");
    }
   
    dhiringrequest(id): Promise<any>{
        return this.httpmanagerService.HttpDelete('hiringrequest',id).then(data =>{
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/hiringrequest/hiringrequest.service.ts